import React from "react";

const ArrowLeft = ({ height = 14.56, width = 8.84 }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 11.957 19.704"
      >
        <path
          id="chevron-right-solid"
          d="M27.812,48.275l8.769,8.769a1.083,1.083,0,0,0,1.531,0l1.023-1.023a1.083,1.083,0,0,0,0-1.53l-6.95-6.982,6.95-6.982a1.083,1.083,0,0,0,0-1.53l-1.023-1.023a1.083,1.083,0,0,0-1.531,0l-8.769,8.769A1.083,1.083,0,0,0,27.812,48.275Z"
          transform="translate(-27.494 -37.657)"
          fill="#fff"
        />
      </svg>
    </>
  );
};
export default ArrowLeft;
